var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueScreenClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8867 0C16.8994 0 21.7734 4.9247 21.7734 11C21.7734 17.0753 16.8994 22 10.8867 22C4.87397 22 0 17.0753 0 11C0 4.9247 4.87397 0 10.8867 0ZM10.8867 2.2C8.57682 2.2 6.36156 3.12714 4.72824 4.77746C3.09493 6.42778 2.17734 8.66609 2.17734 11C2.17734 13.3339 3.09493 15.5722 4.72824 17.2225C6.36156 18.8729 8.57682 19.8 10.8867 19.8C13.1965 19.8 15.4118 18.8729 17.0451 17.2225C18.6784 15.5722 19.596 13.3339 19.596 11C19.596 8.66609 18.6784 6.42778 17.0451 4.77746C15.4118 3.12714 13.1965 2.2 10.8867 2.2ZM10.8867 4.4C11.1533 4.40004 11.4107 4.49895 11.61 4.67799C11.8092 4.85702 11.9365 5.10372 11.9677 5.3713L11.9753 5.5V10.5446L14.9224 13.5223C15.1176 13.7203 15.231 13.9859 15.2394 14.2652C15.2479 14.5446 15.1508 14.8167 14.9678 15.0263C14.7849 15.2359 14.5299 15.3673 14.2545 15.3938C13.9792 15.4203 13.7041 15.34 13.4853 15.169L13.383 15.0777L10.117 11.7777C9.94779 11.6066 9.83912 11.3839 9.80781 11.1441L9.79801 11V5.5C9.79801 5.20826 9.91271 4.92847 10.1169 4.72218C10.321 4.51589 10.5979 4.4 10.8867 4.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueScreenClockIcon);
export default __webpack_public_path__ + "static/media/queueScreenClockIcon.ef5a7da317be27be79528b17af0b3e03.svg";
export { ForwardRef as ReactComponent };